let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7yGDk")).then(() => parcelRequire('6uevy'));